import DuplicateOrderModal from './DuplicateOrderModal';

export default {
  DuplicateOrderModal,
};
